import _slicedToArray from "/Users/marklesbirel/Documents/GitHub/ManualProWeb/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _createForOfIteratorHelper from "/Users/marklesbirel/Documents/GitHub/ManualProWeb/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _classCallCheck from "/Users/marklesbirel/Documents/GitHub/ManualProWeb/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/marklesbirel/Documents/GitHub/ManualProWeb/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/marklesbirel/Documents/GitHub/ManualProWeb/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/Users/marklesbirel/Documents/GitHub/ManualProWeb/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/**
 * @license Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module link/linkimageediting
 */
import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import ImageEditing from '@ckeditor/ckeditor5-image/src/image/imageediting';
import Matcher from '@ckeditor/ckeditor5-engine/src/view/matcher';
import toMap from '@ckeditor/ckeditor5-utils/src/tomap';
import LinkEditing from './linkediting';
import linkIcon from '../theme/icons/link.svg';
/**
 * The link image engine feature.
 *
 * It accepts the `linkHref="url"` attribute in the model for the {@link module:image/image~Image `<image>`} element
 * which allows linking images.
 *
 * @extends module:core/plugin~Plugin
 */

var LinkImageEditing = /*#__PURE__*/function (_Plugin) {
  _inherits(LinkImageEditing, _Plugin);

  var _super = _createSuper(LinkImageEditing);

  function LinkImageEditing() {
    _classCallCheck(this, LinkImageEditing);

    return _super.apply(this, arguments);
  }

  _createClass(LinkImageEditing, [{
    key: "init",
    value: function init() {
      var editor = this.editor;
      editor.model.schema.extend('image', {
        allowAttributes: ['linkHref']
      });
      editor.conversion.for('upcast').add(upcastLink());
      editor.conversion.for('editingDowncast').add(downcastImageLink({
        attachIconIndicator: true
      }));
      editor.conversion.for('dataDowncast').add(downcastImageLink({
        attachIconIndicator: false
      })); // Definitions for decorators are provided by the `link` command and the `LinkEditing` plugin.

      this._enableAutomaticDecorators();

      this._enableManualDecorators();
    }
    /**
     * Processes {@link module:link/link~LinkDecoratorAutomaticDefinition automatic decorators} definitions and
     * attaches proper converters that will work when linking an image.`
     *
     * @private
     */

  }, {
    key: "_enableAutomaticDecorators",
    value: function _enableAutomaticDecorators() {
      var editor = this.editor;
      var command = editor.commands.get('link');
      var automaticDecorators = command.automaticDecorators;

      if (automaticDecorators.length) {
        editor.conversion.for('downcast').add(automaticDecorators.getDispatcherForLinkedImage());
      }
    }
    /**
     * Processes transformed {@link module:link/utils~ManualDecorator} instances and attaches proper converters
     * that will work when linking an image.
     *
     * @private
     */

  }, {
    key: "_enableManualDecorators",
    value: function _enableManualDecorators() {
      var editor = this.editor;
      var command = editor.commands.get('link');
      var manualDecorators = command.manualDecorators;

      var _iterator = _createForOfIteratorHelper(command.manualDecorators),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var decorator = _step.value;
          editor.model.schema.extend('image', {
            allowAttributes: decorator.id
          });
          editor.conversion.for('downcast').add(downcastImageLinkManualDecorator(manualDecorators, decorator));
          editor.conversion.for('upcast').add(upcastImageLinkManualDecorator(manualDecorators, decorator));
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }], [{
    key: "requires",
    get:
    /**
     * @inheritDoc
     */
    function get() {
      return [ImageEditing, LinkEditing];
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "pluginName",
    get: function get() {
      return 'LinkImageEditing';
    }
  }]);

  return LinkImageEditing;
}(Plugin); // Returns a converter that consumes the 'href' attribute if a link contains an image.
//
// @private
// @returns {Function}


export { LinkImageEditing as default };

function upcastLink() {
  return function (dispatcher) {
    dispatcher.on('element:a', function (evt, data, conversionApi) {
      var viewLink = data.viewItem;
      var imageInLink = Array.from(viewLink.getChildren()).find(function (child) {
        return child.name === 'img';
      });

      if (!imageInLink) {
        return;
      } // There's an image inside an <a> element - we consume it so it won't be picked up by the Link plugin.


      var consumableAttributes = {
        attributes: ['href']
      }; // Consume the `href` attribute so the default one will not convert it to $text attribute.

      if (!conversionApi.consumable.consume(viewLink, consumableAttributes)) {
        // Might be consumed by something else - i.e. other converter with priority=highest - a standard check.
        return;
      }

      var linkHref = viewLink.getAttribute('href'); // Missing the 'href' attribute.

      if (!linkHref) {
        return;
      } // A full definition of the image feature.
      // figure > a > img: parent of the link element is an image element.


      var modelElement = data.modelCursor.parent;

      if (!modelElement.is('element', 'image')) {
        // a > img: parent of the link is not the image element. We need to convert it manually.
        var conversionResult = conversionApi.convertItem(imageInLink, data.modelCursor); // Set image range as conversion result.

        data.modelRange = conversionResult.modelRange; // Continue conversion where image conversion ends.

        data.modelCursor = conversionResult.modelCursor;
        modelElement = data.modelCursor.nodeBefore;
      }

      if (modelElement && modelElement.is('element', 'image')) {
        // Set the linkHref attribute from link element on model image element.
        conversionApi.writer.setAttribute('linkHref', linkHref, modelElement);
      }
    }, {
      priority: 'high'
    }); // Using the same priority that `upcastImageLinkManualDecorator()` converter guarantees
    // that manual decorators will decorate the proper element.
  };
} // Return a converter that adds the `<a>` element to data.
//
// @private
// @params {Object} options
// @params {Boolean} options.attachIconIndicator=false If set to `true`, an icon that informs about the linked image will be added.
// @returns {Function}


function downcastImageLink(options) {
  return function (dispatcher) {
    dispatcher.on('attribute:linkHref:image', function (evt, data, conversionApi) {
      // The image will be already converted - so it will be present in the view.
      var viewFigure = conversionApi.mapper.toViewElement(data.item);
      var writer = conversionApi.writer; // But we need to check whether the link element exists.

      var linkInImage = Array.from(viewFigure.getChildren()).find(function (child) {
        return child.name === 'a';
      });
      var linkIconIndicator;

      if (options.attachIconIndicator) {
        // Create an icon indicator for a linked image.
        linkIconIndicator = writer.createUIElement('span', {
          class: 'ck ck-link-image_icon'
        }, function (domDocument) {
          var domElement = this.toDomElement(domDocument);
          domElement.innerHTML = linkIcon;
          return domElement;
        });
      } // If so, update the attribute if it's defined or remove the entire link if the attribute is empty.


      if (linkInImage) {
        if (data.attributeNewValue) {
          writer.setAttribute('href', data.attributeNewValue, linkInImage);
        } else {
          var viewImage = Array.from(linkInImage.getChildren()).find(function (child) {
            return child.name === 'img';
          });
          writer.move(writer.createRangeOn(viewImage), writer.createPositionAt(viewFigure, 0));
          writer.remove(linkInImage);
        }
      } else {
        // But if it does not exist. Let's wrap already converted image by newly created link element.
        // 1. Create an empty link element.
        var linkElement = writer.createContainerElement('a', {
          href: data.attributeNewValue
        }); // 2. Insert link inside the associated image.

        writer.insert(writer.createPositionAt(viewFigure, 0), linkElement); // 3. Move the image to the link.

        writer.move(writer.createRangeOn(viewFigure.getChild(1)), writer.createPositionAt(linkElement, 0)); // 4. Inset the linked image icon indicator while downcast to editing.

        if (linkIconIndicator) {
          writer.insert(writer.createPositionAt(linkElement, 'end'), linkIconIndicator);
        }
      }
    });
  };
} // Returns a converter that decorates the `<a>` element when the image is the link label.
//
// @private
// @returns {Function}


function downcastImageLinkManualDecorator(manualDecorators, decorator) {
  return function (dispatcher) {
    dispatcher.on("attribute:".concat(decorator.id, ":image"), function (evt, data, conversionApi) {
      var attributes = manualDecorators.get(decorator.id).attributes;
      var viewFigure = conversionApi.mapper.toViewElement(data.item);
      var linkInImage = Array.from(viewFigure.getChildren()).find(function (child) {
        return child.name === 'a';
      });

      var _iterator2 = _createForOfIteratorHelper(toMap(attributes)),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _step2$value = _slicedToArray(_step2.value, 2),
              key = _step2$value[0],
              val = _step2$value[1];

          conversionApi.writer.setAttribute(key, val, linkInImage);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    });
  };
} // Returns a converter that checks whether manual decorators should be applied to the link.
//
// @private
// @returns {Function}


function upcastImageLinkManualDecorator(manualDecorators, decorator) {
  return function (dispatcher) {
    dispatcher.on('element:a', function (evt, data, conversionApi) {
      var viewLink = data.viewItem;
      var consumableAttributes = {
        attributes: manualDecorators.get(decorator.id).attributes
      };
      var matcher = new Matcher(consumableAttributes);
      var result = matcher.match(viewLink); // The link element does not have required attributes or/and proper values.

      if (!result) {
        return;
      } // Check whether we can consume those attributes.


      if (!conversionApi.consumable.consume(viewLink, result.match)) {
        return;
      } // At this stage we can assume that we have the `<image>` element.


      var modelElement = data.modelCursor.parent;
      conversionApi.writer.setAttribute(decorator.id, true, modelElement);
    }, {
      priority: 'high'
    }); // Using the same priority that `upcastLink()` converter guarantees that the linked image was properly converted.
  };
}